import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'iconfile'
})

export class IconFilePipe implements PipeTransform {

    transform(value: string) {
        if(value.match(/\.(pdf|txt|doc|docx|exel|PDF|TXT|DOC|DOCX|EXEL)$/)){
            return {"file alternate icon": true};
        } else if (value.match(/\.(mp3|MP3|wav|WAV|wma|WMA)$/)){
            return {"file audio icon" : true};
        } else if(value.match(/\.(3gp|avi|mp4|mpeg|mpg|3GP|AVI|MP4|MPEG|MPG)$/)){
            return {"file video icon": true};
        } else if(value.match(/\.(jpg|jpeg|png|gif|bmp|JPG|JPEG|PNG|GIF|BMP)$/)){
            return {"file image icon": true};
        } else {
            return {"download icon": true};
        }
    }
}